<div class="field">
    <label [for]="inputId()">{{ label() }}</label>
    <cl-input-file [inputId]="inputId()" [accept]="accept()" [formControl]="control()" />
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
